import pdfMake from "@digicole/pdfmake-rtl/build/pdfmake";
import pdfFonts from "@digicole/pdfmake-rtl/build/vfs_fonts";
import iransans from "../../assets/fonts/vazir/Farsi-Digits/Vazir-Light-FD.ttf";
import { numberFormatter } from "../Number/numberFormatter";
import momentJalai from "moment-jalaali";

var fontLoaded = false;

var loadFont = function () {
  if (fontLoaded) return Promise.resolve();
  pdfMake.vfs = pdfFonts;
  return fetch(iransans)
    .then(function (res) {
      return res.arrayBuffer();
    })
    .then(function (buf) {
      var base64 = btoa(
        new Uint8Array(buf).reduce(function (data, byte) {
          return data + String.fromCharCode(byte);
        }, "")
      );
      pdfMake.vfs["IRANSansWeb.ttf"] = base64;
      pdfMake.fonts = {
        IRANSans: {
          normal: "IRANSansWeb.ttf",
          bold: "IRANSansWeb.ttf",
          italics: "IRANSansWeb.ttf",
          bolditalics: "IRANSansWeb.ttf",
        },
        Nillima: {
          normal: "IRANSansWeb.ttf",
          bold: "IRANSansWeb.ttf",
          italics: "IRANSansWeb.ttf",
          bolditalics: "IRANSansWeb.ttf",
        },
        Roboto: {
          normal: "IRANSansWeb.ttf",
          bold: "IRANSansWeb.ttf",
          italics: "IRANSansWeb.ttf",
          bolditalics: "IRANSansWeb.ttf",
        },
      };
      fontLoaded = true;
    });
};

function getStatusText(status, cashed_date_fa, bounced_date_fa, returned_date_fa) {
  if (status === "current") {
    return "جاری";
  }
  if (status === "cashed") {
    return (cashed_date_fa || "") + " - پاس شده";
  } else if (status === "bounced") {
    return (bounced_date_fa || "") + " - برگشت خورده";
  } else if (status === "returned-settlement") {
    return (returned_date_fa || "") + " - عودتی تسویه";
  } else if (status === "returned-unresolved") {
    return (returned_date_fa || "") + " - عودتی بلاتکلیف";
  }
  return "-";
}

export var generateChequePdf = function (cheque) {
  loadFont().then(function () {
    var docDefinition = {
      defaultStyle: {
        font: "IRANSans",
        fontSize: 11,
      },
      pageMargins: [30, 30, 30, 30],
      content: [
        {
          text: "اطلاعات چک شماره " + (cheque.cheque_id || ""),
          style: "title",
          alignment: "center",
          margin: [0, 0, 0, 20],
        },
        {
          table: {
            widths: ["*", "*"],
            body: [
              [
                { text: "شماره چک", style: "label" },
                { text: cheque.cheque_id || "-", alignment: "center" },
              ],
              [
                { text: "شماره صیاد", style: "label" },
                { text: cheque.icis || "-", alignment: "center" },
              ],
              [
                { text: "مبلغ", style: "label" },
                { text: numberFormatter(cheque.amount), alignment: "center" },
              ],
              [
                { text: "سررسید", style: "label" },
                { text: cheque.due_date_fa || "-", alignment: "center" },
              ],
              [
                { text: "بانک", style: "label" },
                { text: cheque.bank || "-", alignment: "center" },
              ],
              [
                { text: "شعبه", style: "label" },
                { text: cheque.bank_branch || "-", alignment: "center" },
              ],
              [
                { text: "شماره حساب", style: "label" },
                { text: cheque.account || "-", alignment: "center" },
              ],
              [
                { text: "دهنده", style: "label" },
                {
                  text: cheque.giver_user_fullname || "مشخص نشده",
                  alignment: "center",
                },
              ],
              [
                { text: "گیرنده", style: "label" },
                {
                  text:
                    cheque.recieverable_name ||
                    cheque.reciver_user_fullname ||
                    "مشخص نشده",
                  alignment: "center",
                },
              ],
              [
                { text: "مالک", style: "label" },
                {
                  text: cheque.first_party_fullname || "مشخص نشده",
                  alignment: "center",
                },
              ],
              [
                { text: "در وجه", style: "label" },
                {
                  text: cheque.second_party_fullname || "مشخص نشده",
                  alignment: "center",
                },
              ],
              [
                { text: "ضامن", style: "label" },
                { text: cheque.guarantor_fullname || "-", alignment: "center" },
              ],
              [
                { text: "تاریخ تحویل", style: "label" },
                {
                  text: cheque.delivered_date_fa,
                  alignment: "center",
                },
              ],
              [
                { text: "وضعیت", style: "label" },
                {
                  text: getStatusText(
                    cheque.status,
                    cheque.cashed_date_fa,
                    cheque.bounced_date_fa,
                    cheque.returned_date_fa,
                  ),
                  alignment: "center",
                },
              ],
              [
                { text: "توضیحات", style: "label" },
                { text: cheque.description || "-", alignment: "center" },
              ],
            ],
          },
          layout: {
            hLineWidth: function (i) {
              return 0.5;
            },
            vLineWidth: function () {
              return 0.5;
            },
            hLineColor: function () {
              return "#cccccc";
            },
            vLineColor: function () {
              return "#cccccc";
            },
            fillColor: function (rowIndex) {
              return rowIndex % 2 === 0 ? "#f5f5f5" : null;
            },
            paddingLeft: function () {
              return 8;
            },
            paddingRight: function () {
              return 8;
            },
            paddingTop: function () {
              return 4;
            },
            paddingBottom: function () {
              return 4;
            },
          },
        },
      ],
      styles: {
        title: {
          fontSize: 16,
          bold: true,
          color: "#01579b",
        },
        label: {
          bold: true,
          alignment: "right",
          color: "#333333",
        },
      },
    };

    var fileName = "cheque_" + (cheque.cheque_id || cheque.id) + "_" + momentJalai().format("jYYYY-jMM-jDD_HH-mm") + ".pdf";
    pdfMake.createPdf(docDefinition).download(fileName);
  }).catch(function () {});
};

export default generateChequePdf;
